export interface VehicleType {
  id: string;
  name: string;
  category: string;
  image: string;
  description: string;
  passengers: number;
  luggage: number;
  hourlyRate: number;
  perDayKm: number;
  totalPrice: number;
  amenities: string[];
  features: string[];
}

export const categories = ['All', 'Sedan', 'SUV', 'Premium SUV', 'Buses'];

export const vehicles: VehicleType[] = [
  {
    id: 'sedan-variety',
    name: 'Swift Dzire | Honda Amaze | Hyundai Aura',
    category: 'Sedan',
    image: '/images/vehicles/sedan-variety.jpg',
    description: 'The epitome of luxury sedans, our Swift Dzire / Honda Amaze / Hyundai Aura offers executive comfort with premium leather interior, advanced climate control, and a smooth, quiet ride perfect for business travel.',
    passengers: 4,
    luggage: 2,
    perDayKm: 13,
    totalPrice: 3900,
    hourlyRate: 100,
    amenities: ['Bottled Water', 'Mobile Charging', 'Climate Control'],
    features: ['Climate Control', 'Power Outlets']
  },
  {
    id: 'suv-variety',
    name: 'Ertiga | XL6 | Kia Carens | Romeo',
    category: 'SUV',
    image: '/images/vehicles/suv-variety.jpg',
    description: 'A blend of luxury and performance, the Ertiga / XL6 / Kia Carens / Romeo provides a dynamic driving experience with sophisticated comfort features, making it ideal for executives who appreciate both technology and style.',
    passengers: 6,
    luggage: 4,
    perDayKm: 17,
    totalPrice: 5400,
    hourlyRate: 125,
    amenities: ['Bottled Water', 'Mobile Charging', 'Climate Control'],
    features: ['Climate Control', 'Power Outlets']
  },
  {
    id: 'premium-suv-variety',
    name: 'Innova Crysta | XUV700 | Innova Hycross | Thar | Scorpio',
    category: 'Premium SUV',
    image: '/images/vehicles/premium-suv-variety.jpg',
    description: 'The Innova Crysta / XUV700 / Innova Hycross / Thar / Scorpio combines imposing presence with refined luxury, offering spacious seating, premium amenities, and ample luggage capacity for small groups or executives requiring extra space.',
    passengers: 6,
    luggage: 6,
    perDayKm: 20,
    totalPrice: 6300,
    hourlyRate: 150,
    amenities: ['Bottled Water', 'Mobile Charging', 'Climate Control'],
    features: ['Climate Control', 'Power Outlets']
  },
  {
    id: 'buses-17-seater',
    name: 'Tempo Traveller',
    category: 'Buses',
    image: '/images/vehicles/tempo-traveller.jpg',
    description: 'Our Tempo Traveller provides exceptional comfort for larger groups, featuring high-end finishes, configurable seating, and premium entertainment options for productive travel time.',
    passengers: 17,
    luggage: 14,
    perDayKm: 30,
    totalPrice: 9500,
    hourlyRate: 150,
    amenities: ['Bottled Water', 'Mobile Charging', 'Climate Control'],
    features: ['Climate Control', 'Power Outlets']
  },
  {
    id: 'buses-20-seater',
    name: 'Mini Bus',
    category: 'Buses',
    image: '/images/vehicles/mini-bus.jpg',
    description: 'The Mini Bus provides exceptional comfort for larger groups, featuring high-end finishes, configurable seating, and premium entertainment options for productive travel time.',
    passengers: 33,
    luggage: 22,
    perDayKm: 45,
    totalPrice: 14000,
    hourlyRate: 200,
    amenities: ['Bottled Water', 'Mobile Charging', 'Climate Control'],
    features: ['Climate Control', 'Power Outlets']
  },
  {
    id: 'buses-56-seater',
    name: 'Luxury Bus',
    category: 'Buses',
    image: '/images/vehicles/luxury-bus.jpg',
    description: "Our Luxury Bus provides exceptional comfort for larger groups, featuring high-end finishes, configurable seating, and premium entertainment options for productive travel time.",
    passengers: 56,
    luggage: 50,
    perDayKm: 60,
    totalPrice: 18500,
    hourlyRate: 300,
    amenities: ['Bottled Water', 'Mobile Charging', 'Climate Control'],
    features: ['Climate Control', 'Power Outlets']
  }
];

